




































import { EnumPersistenceStatus } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { GuidHelper } from '@/libs/com/MetaPattern/Product/IDE/Util/GuidHelper';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { APP } from '@/api/com/MetaPattern/MDA/MD/Base/APP';
import PGRowWorkScopeValue from '@/components/common/property/PGRowWorkScopeValue.vue';
import { WorkScope } from '@/api/com/MetaPattern/MDA/MD/Base/WorkScope';

@Component({
  components: {
    PGRowWorkScopeValue
  }
})
export default class AddAPP extends Vue {
  private app: APP = null;

  constructor() {
    super();
    this.app = new APP();
    this.app.designId = GuidHelper.getGuid();
    this.app.persistenceStatus = EnumPersistenceStatus.Create;
  }

  cancel() {
    (this.$refs.app as any).resetFields();
    this.$emit('closeDialog', null);
  }

  confirm() {
    (this.$refs.app as any).validate((valid: any) => {
      if (valid) {
        this.app.workScope = this.getWorkScopes().find((item: WorkScope) => item.id === this.app.workScope_ID) as WorkScope;
        this.$emit('closeDialog', this.app);
      } else {
        return false;
      }
    });
  }

  beforeClose() {
    this.$confirm('关闭后未保存的信息将会丢失，确认要关闭么？')
      .then(_ => {
        this.cancel();
      })
      .catch(_ => {
        // do nothing
      });
  }

  getWorkScopes() {
    return this.$store.state.ModuleMD.workScopes;
  }

  get labelWidth() {
    return '100px';
  }
}

